import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';

const Hr = ({ style }) => (
    <View
        style={[
            {
                height: 1,
                backgroundColor: '#6C6C6C',
                alignSelf: 'stretch'
            },
            style
        ]}
    />
);

Hr.propTypes = {
    style: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number])
};

Hr.defaultProps = {
    style: {}
};

export default Hr;
